// utils.ts
export function getContrastColor(hexColor) {
    if (!hexColor) return "#000000"; // กรณีไม่มีสี
  
    // ลบ # ถ้ามี
    const hex = hexColor.replace("#", "");
  
    // แยกค่า RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
  
    // คำนวณความสว่าง (YIQ formula)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  
    // ถ้าแสงมาก ใช้สีดำ ถ้ามืด ใช้สีขาว
    return yiq >= 128 ? "#000000" : "#ffffff";
  }
  